import {Component} from '@angular/core';
import {BaseAccountsComponent} from "./base.accounts.component";
import {ClientsService} from "../../models/clients/clients.service";

import {Router, ActivatedRoute} from '@angular/router';
import {DataTable} from "../../services/DataTable";

import {BadgesService} from "../../models/badges/badges.service";
import {BadgesHelper} from "../../services/BadgesHelper";

@Component({
    selector: 'accounts',
    templateUrl: 'accounts.template.html'
})
export class UnderwriterAccountsComponent extends BaseAccountsComponent
{
    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        public clientsService: ClientsService,

        public badgesService:BadgesService,
        public badgesHelper: BadgesHelper
    ) {
        super(router, route, clientsService, badgesService, badgesHelper);
    }

    protected getFields(){
        return [{'visible': ClientsService.CLIENT_VISIBLE_TRUE}, {'has_pricing': 1}];
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/accounts/underwriter.accounts.component.ts